import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../../shared/api-response.model';
import {ApiVisa} from '../../shared/api-visa.model';
import {LabelCriteriaModelQuery, LabelQueryCriteriaClass} from '../../../criteria';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenerateRefereshTokenService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/generate-refresh-token';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/generate-refresh-token';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/generate-refresh-token';
    this.httpClient = http;
  }

  generateRefereshToken(branchGuid, code, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?branch_guid=' + branchGuid + '&oAuthCode=' + code;
    console.log("generateRefereshToken", url)
    return this.httpClient.post(url, null, this.getHttpHeader(apiVisa));
  }

}
